
import { defineComponent } from "vue";
import OwnerService from "@/services/OwnerService";
import router from "@/router";
import { IOS_URL, ANDROID_URL, QR_CODE_URL } from "@/const";

const ownerService = new OwnerService();

export default defineComponent({
  name: "Topbar",
  props: {
    isConnected: String,
    owner: Object,
  },
  setup(props) {
    console.log("PROPS", props);
  },
  methods: {
    // click on try the app button
    tryApp: async () => {
      // if android or iOS redirect to the stores
      // const androidDevices = ["Android"];
      // const iosDevices = ["iPhone", "iPad", "iPod"];

      const userDevice = navigator.userAgent;
      console.log("userDevice", userDevice);
      if (userDevice.includes("iPhone") || userDevice.includes("iPod")) {
        window.open(IOS_URL); // app store
      } else if (userDevice.includes("Android")) {
        window.open(ANDROID_URL); // android store
      } else {
        // if web, open window with qr code
        window.open(
          QR_CODE_URL,
          "mywindow",
          "menubar=1,resizable=1,width=350,height=250"
        );
      }
    },
    /**
     * Logout the connected user
     * remove items from LS
     * reload page
     */
    logout: async () => {
      ownerService.logoutOwner();
      window.location.reload();
    },
  },
});
